import { cn } from "@/shared/lib/utils";
import { s } from "@/shared/strings";

// Logotipo Arena: palavra em Archivo Expanded Black com o A em âmbar.
export function Logo({
  size = "md",
  className,
}: {
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const cls = size === "lg" ? "text-56" : size === "sm" ? "text-22" : "text-40";
  return (
    <div
      className={cn("expanded text-chalk font-black tracking-tight select-none", cls, className)}
    >
      <span className="text-amber-fg">A</span>RENA
    </div>
  );
}

export function Tagline({ className }: { className?: string }) {
  return <p className={cn("text-16 text-chalk-2", className)}>{s.tagline}</p>;
}
